import { FC } from 'react';

import { CustomizationShell, ScreenSavers } from './components';

export const CustomizationTab: FC = () => {
  return (
    <>
      <CustomizationShell />
      <ScreenSavers />
    </>
  );
};
